import styled from 'styled-components'
import { getTheme } from 'helpers'
export default styled.div`
  background-color: white;
  border: 1px solid ${getTheme`colors.border`};
  padding: 20px;
`



// WEBPACK FOOTER //
// ./src/components/ContentWrapper.js